import { z } from 'zod';

import { UuidSchema } from '../../common/id/id';

/**
 * A member asking to meet at a partner venue.
 *
 * ## Both ids are named by the client, and that was considered
 *
 * P23b4's rule is that a uuid a client can **name** is a uuid a client can
 * **aim**, and that such a field should leave the write contract rather than
 * gain a validator. It does not reach here, for a reason worth writing down so
 * nobody re-opens it: neither id is derivable server-side. A member may hold
 * several active matches, so the server cannot know **which** of them this
 * booking is for; and a slot belongs to a venue the member chose. There is no
 * shorter request that still says what was asked for.
 *
 * What replaces the removal is the gate, not a validator: `matchId` is checked
 * for **membership** (the caller is one of the two members) and for
 * **liveness** (`MATCHING_IS_MATCH_ACTIVE`), both before anything is written.
 * Aiming this field at somebody else's match reaches a 404, never a booking.
 *
 * The **venue** is deliberately absent even though the booking stores one: it is
 * a property of the slot, and accepting it would let a body disagree with the
 * row — the same reason `VenueSlotWritableShape` leaves the venue to the route.
 */
export const BookingCreateSchema = z
  .object({
    matchId: UuidSchema,
    slotId: UuidSchema,
  })
  .strict();

export type BookingCreateRequest = z.infer<typeof BookingCreateSchema>;
